<template>
    <v-data-table
        :headers="headers"
        :items="entities"
        class="elevation-1"
        :footer-props="{ 'itemsPerPageOptions': [50, 100, 200, -1] }"
    >
        <template v-slot:top>
            <v-toolbar flat>
                <v-toolbar-title>{{ $t('src\\views\\reports\\list.5774') }}</v-toolbar-title>
                <v-spacer />
                <v-btn v-if="user.adminAccess && user.adminAccess.reports >= ACCESS.WRITE" color="primary" @click="create">
                    <v-icon>mdi-plus</v-icon>{{ $t('src\\views\\reports\\list.3503') }}</v-btn>
            </v-toolbar>
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
            {{ item.createdAt | moment('DD.MM.YYYY HH:mm') }}
        </template>
        <template v-slot:[`item.edit`]="{ item }">
            <v-icon color="primary" @click="edit(item._id)">mdi-pencil</v-icon>
        </template>
    </v-data-table>
</template>

<script>
    import store from '@/store';
    import { mapState } from 'vuex';
    import { ACCESS } from '@/vars';

    export default {
        name: 'ReportsList',
        components: {
        },
        data: () => ({
            ACCESS,
            headers: [],
        }),
        computed: {
            ...mapState('auth', ['user']),
            ...mapState('reports', ['entities']),
        },
        async mounted() {
            await store.dispatch('auth/fetch');
            await store.dispatch('reports/fetch', {});
            this.headers = [
                { text: this.$t('src\\views\\reports\\list.createdAt'), value: 'createdAt' },
                { text: this.$t('src\\views\\reports\\list.code'), value: 'code' },
                { text: this.$t('src\\views\\reports\\list.title'), value: 'title' },
            ]
            if(this.user && this.user.adminAccess && this.user.adminAccess.reports >= ACCESS.WRITE) {
                this.headers.push({ text: this.$t('src\\views\\news\\list.edit'), align: 'right', value: 'edit' })
            }
        },
        methods: {
            async create() {
                await this.$router.push({ name: 'reports-create' });
            },
            async edit(id) {
                await this.$router.push({ name: 'reports-edit', params: { id } });
            }
        }
    }
</script>
